import { h, Teleport } from 'vue';
import CookieBanner from 'Web/Shared/CookieBanner.vue';

export function renderBanner() {
  return h(Teleport, { to: '#banner' }, h(CookieBanner));
}
